/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Patient dates of service from/to values returned in detailed search results
 */
export interface PatientServiceDatesIntegrationViewModel {
  /**
   * Procedure service from date
   */
  fromDate?: string;
  /**
   * Procedure service to date
   */
  toDate?: string;
}
